import './EmptyInputs.scss';
import { HiOutlinePlus } from 'react-icons/hi';
import { MdOutlineUploadFile, MdRefresh } from 'react-icons/md';
import { Button } from '@Components/Button';
import { Background, Size } from '@Components/designConstants';
import EmptyIcon from './empty.svg?react';

interface EmptyInputsProps {
  inputType: string;
  showAddMediaInputModal: () => void;
  openImportDataModal?: () => void;
  hasError?: boolean;
  onRetry?: () => void;
}

export const EmptyInputs = ({
  inputType,
  showAddMediaInputModal,
  openImportDataModal,
  hasError = false,
  onRetry = () => {}
}: EmptyInputsProps) => {
  if (hasError) {
    return (
      <div className='empty-inputs-container'>
        <EmptyIcon />
        <h1 className='empty-inputs-title'>Couldn&apos;t load your data.</h1>
        <h2 className='empty-inputs-subtitle'>Something went wrong. Please try again.</h2>
        <div className='empty-inputs-buttons'>
          <Button
            size={Size.LG}
            background={Background.DARK}
            leadingElement={<MdRefresh />}
            onClick={onRetry}
          >
            Retry
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className='empty-inputs-container'>
      <EmptyIcon />
      <h1 className='empty-inputs-title'>No data to show here yet.</h1>
      <h2 className='empty-inputs-subtitle'>Add {inputType} to get started!</h2>
      <div className='empty-inputs-buttons'>
        <Button
          size={Size.LG}
          background={Background.DARK}
          leadingElement={<HiOutlinePlus />}
          onClick={showAddMediaInputModal}
        >
          Add {inputType}
        </Button>
        {openImportDataModal && (
          <Button
            size={Size.LG}
            leadingElement={<MdOutlineUploadFile />}
            onClick={openImportDataModal}
          >
            Bulk Upload {inputType}
          </Button>
        )}
      </div>
    </div>
  );
};
